import type { UseMutationOptions } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";

import type {
  LoginOperationRequest,
  VerifyLoginCodeRequest,
} from "@its4plan/authentication";

import { useLoginApi } from "./common";

export function useLogin(
  options?: UseMutationOptions<void, unknown, LoginOperationRequest>,
) {
  const loginApi = useLoginApi();
  return useMutation({
    ...options,
    mutationKey: ["login"],
    mutationFn: (req: LoginOperationRequest) => loginApi.login(req),
  });
}

export function useVerifyLoginCode(
  options?: UseMutationOptions<string, unknown, VerifyLoginCodeRequest>,
) {
  const loginApi = useLoginApi();
  return useMutation({
...options,
    mutationKey: ["verifyLoginCode"],
    mutationFn: (req: VerifyLoginCodeRequest) =>
loginApi.verifyLoginCode(req).then((data) => data.token),
  });
}
